"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsButtonParentNavigate = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _Undo = _interopRequireDefault(require("@mui/icons-material/Undo"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _NamedRoutes = require("../../constants/NamedRoutes");
var _DmsButtonNavigate = require("../DmsButtonNavigate/DmsButtonNavigate");
const _excluded = ["endIcon", "text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A button to navigate to the parent route, with a default left arrow icon
 * and text internationalized to "Parent Route."
 *
 * @component
 * @param {Object} props - The component props, inheriting all props from DmsButtonNavigate.
 * @returns {JSX.Element} The DmsButtonParentNavigate component.
 */
const DmsButtonParentNavigate = _ref => {
  let {
      endIcon = /*#__PURE__*/_react.default.createElement(_Undo.default, null),
      text = _reactIntlUniversal.default.get('parent.route').d('Parent Route')
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const location = (0, _reactRouterDom.useLocation)();
  const getParentRoute = () => {
    const segments = location.pathname.split('/').filter(Boolean);
    if (segments.length > 1) {
      return "/".concat(segments.slice(0, -1).join('/'));
    }
    return _NamedRoutes.ROUTES.Home;
  };
  const parentRoute = getParentRoute();
  return /*#__PURE__*/_react.default.createElement(_DmsButtonNavigate.DmsButtonNavigate, _extends({
    route: parentRoute,
    endIcon: endIcon,
    text: text
  }, props));
};
exports.DmsButtonParentNavigate = DmsButtonParentNavigate;
DmsButtonParentNavigate.propTypes = _objectSpread(_objectSpread({}, _DmsButtonNavigate.DmsButtonNavigate.propTypes), {}, {
  endIcon: _propTypes.default.node,
  text: _propTypes.default.string
});